import { MultiSelect } from '../multiselect/MultiSelect';
import { Topic } from '../../types/Topic';
import { FiltersToggle } from './FiltersToggle';
import { FiltersObject } from '../../utils';
import { useTranslations } from 'next-intl';

type QuickFiltersProps = {
    filters: FiltersObject;
    setFilters: (filters: FiltersObject) => void;
    topics: Topic[];
    onClickAllFilters?: () => void;
    isDisabled: boolean;
};

const QuickFilters = ({
    filters,
    isDisabled,
    onClickAllFilters,
    setFilters,
    topics
}: QuickFiltersProps) => {
    const t_filters = useTranslations('filtering');

    const updateFilterObject = (partialFilterObject: Partial<FiltersObject>) => {
        setFilters({
            ...filters,
            ...partialFilterObject
        });
    };

    const allServiceOptions = topics.map((topic: Topic) => ({
        id: topic.id.toString(),
        label: topic.title,
        isSelected: !!filters.services.find((filterService) => filterService.id === topic.id)
    }));

    const handleTopicChange = (selectedTopicIDs: string[]) => {
        updateFilterObject({
            topics: topics.filter((topic) =>
                selectedTopicIDs.find((id) => id === topic.id.toString())
            )
        });
    };

    const handleExampleFilterTypeChange = (selectedIDs: string[]) => {
        updateFilterObject({
            locationType: selectedIDs.map((id) => id)
        });
    };

    return (
        <>
            <MultiSelect
                name='services'
                allOptions={allServiceOptions}
                placeHolder={t_filters('topics')}
                onChange={handleTopicChange}
                disabled={isDisabled}
            />
            <MultiSelect
                name='example'
                allOptions={[]}
                placeHolder={'Filter'}
                onChange={handleExampleFilterTypeChange}
                disabled={isDisabled}
            />
            {onClickAllFilters && (
                <FiltersToggle
                    onClick={onClickAllFilters}
                    isDisabled={isDisabled}
                    filters={filters}
                />
            )}
        </>
    );
};

export { QuickFilters };
